<template>
    <modal-component
        :id="'add-client-from-org-modal'"
        :visible="visible"
        :title="'Add Clients from Organization'"
        :size="'md'"
        @close="handleClose"
    >
        <h6>{{ organization.name }}</h6>
        <input
            type="text"
            id="query"
            class="form-control form-control-sm  mb-1"
            v-model="query"
            autocomplete="off"
            placeholder="Search Patient Email or Name"
        />
        <div class="clients-list" v-show="filteredClients.length">
            <div
                class="d-flex flex-row p-2 list-item bg-white"
                v-for="client in filteredClients"
                :key="client.name"
            >
                <div class="d-flex flex-column justify-content-center">
                    <div class="form-check">
                        <input
                            class="form-check-input cursor-pointer"
                            type="checkbox"
                            :value="client.id"
                            :id="client.id"
                            v-model="selectedClients"
                        />
                    </div>
                </div>
                <div>
                    <img class="client-image" :src="client.profile_photo_url" />
                </div>
                <div class="ml-3 d-block">
                    <h4 class="p-0 m-0">
                        <em>{{ client.name }}</em>
                    </h4>
                    <p class="p-0 m-0">
                        <em>Last Updated: {{ moment(client.updated_at).format("MM/DD/YYYY") }}</em>
                    </p>
                </div>
            </div>
        </div>

        <section class="d-flex flex-row justify-content-around tc mt-3">
            <button class="btn btn-dark" @click="handleClose">
                Cancel
            </button>
            <button
                :disabled="!selectedClients.length"
                class="btn btn-primary"
                @click="attachSelectedClients"
            >
                Add Selected
            </button>
        </section>

        <errors :errors="errors"></errors>
    </modal-component>
</template>

<script>
import ModalComponent from "../../ui/ModalComponent";
import { errors } from "../../../plugins/errors";

export default {
    name: "AddClientFromOrgModal",
    props: ["user", "organization", "currentClients", "visible", "handleClose"],
    mixins: [errors],
    components: { ModalComponent },
    data() {
        return {
            clients: [],
            selectedClients: [],
            query: "",
        };
    },
    computed: {
        filteredClients() {
            const userMap = this.currentClients.map(client => client.id);
            return this.clients.filter(
                client =>
                    // show in list if the client's name matches the query
                    // and the client isn't already assigned to this user/therapist
                    client.name.toLowerCase().indexOf(this.query.toLowerCase()) >= 0 &&
                    !userMap.includes(client.id)
            );
        },
    },
    watch: {
        visible() {
            // when modal becomes visible, grab data
            if (this.visible) {
                this.fetchClients();
            }
            // always reset the selected clients
            this.selectedClients = [];
        },
    },
    methods: {
        fetchClients() {
            axios.get(`/api/organizations/${this.organization.id}/patients`).then(response => {
                this.clients = response.data.data;
            });
        },
        attachSelectedClients() {
            this.setErrors();
            let payload = {
                patient_ids: this.selectedClients,
            };
            axios
                .post(`/api/users/${this.user.id}/patient`, payload)
                .then(response => {
                    this.handleClose();
                    this.selectedClients = [];
                })
                .catch(error => {
                    console.error(error);
                    this.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.modal-header {
    padding-bottom: 0.5rem;
}

.clients-list {
    overflow-y: scroll;
    max-height: 50vh;
    border: solid 1px #bfbfbf;
}

.client-image {
    width: 64px;
    height: 64px;
}

.list-item {
    border-bottom: solid 1px #bfbfbf;
}

.list-item:last-of-type {
    border-bottom: none;
}

.form-check-input {
    margin-top: auto;
    margin-bottom: auto;
}
</style>
